export const sessionLocation = (sessionId: string, urlString: string) => {
  const url = new URL(urlString);

  url.searchParams.set('eventSessionId', sessionId);
  url.searchParams.delete('search');
  return url.href;
};
